export const SETTINGS_TABS = {
	PERSONAL: 'PERSONAL',
	TAXES: 'TAXES',
	BILLING: 'BILLING',
	ACCESS: 'ACCESS',
} as const
